import React, { useState, useEffect } from 'react';
import { ipApi } from '../services/api';

/** Small, subtle — letterhead on/off for all hospital PDFs. */
export default function LetterheadPdfToggle({ enabled = true, onSaved, className = '' }) {
  const [on, setOn] = useState(enabled !== false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setOn(enabled !== false);
  }, [enabled]);

  const toggle = async (checked) => {
    setOn(checked);
    setBusy(true);
    try {
      await ipApi.patchHospitalProfile({ letterheadOnPdf: checked });
      onSaved?.(checked);
    } catch {
      setOn(!checked);
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className={`pdf-lh-toggle ${className}`.trim()} title="Apply hospital letterhead on receipts, Rx, lab & discharge PDFs">
      <input
        type="checkbox"
        checked={on}
        disabled={busy}
        onChange={(e) => toggle(e.target.checked)}
      />
      <span>Letterhead on PDFs</span>
    </label>
  );
}
